import * as _ from 'lodash';
import * as i18nIsoCountries from 'i18n-iso-countries';

export function getCountryName(countryCode: string, language: string): string {
    return i18nIsoCountries.getName(_.upperCase(countryCode), language);
}
